export const MAX_SEGMENTS_COUNT = 7;
export const DROPDOWN_GROUPS_HEIGTH = 264;
export const DROPDOWN_SEGMENTS_HEIGTH = 332;
export const PLACEHOLDER_SIZE = {
    width: 400,
    heigth: 39,
};
export const WEBSITE_ID_KEY = "WEBSITE#";
export const WEBSITE_ID = "WEBSITE";
export const SEGMENT_ID = "SEGMENT";

export const DESKTOP_WEB_SOURCE = "Desktop";
export const MAX_SEGMENTS_ALLOWED_DURATION_FILTER = 10;

export const ASSETS_ERROR = {
    AssetIsNotAccessible: {
        title: "dashboard.widget.error.asset.is.not.accessible",
        subTitle: "dashboard.widget.error.asset.is.not.accessible.subtitle",
    },
    NumberOfSegmentsDontFitRequestedPeriod: {
        title: "dashboard.widget.error.period.dont.fit",
    },
};
